import React, { Component } from 'react';
import Draggable from 'react-draggable';
import SaveChanges from './addons-save.component';

//styles and icons
import { Row, Col } from 'react-bootstrap';
import ImageOutlinedIcon from '@material-ui/icons/ImageOutlined';

// this component represents the img-editor addon of the video recorder 

export default class AddonImage extends Component {

    constructor() {
        super();
        this.state = {
            imgFiles: [] ,
            fileObj : [] ,
            viewImgDetails : []
        };
    }
    callback = (data) => {
        if (data === 'save') 
        {
            this.saveData();
            this.resetdata();
            this.hideAddonsBtns();

        } else if (data === 'clear') {
            this.resetdata();
            this.hideAddonsBtns();
            this.viewImgs = null;
            this.props.callbackFromParent(0 ,"remove flag");
        }
    }
    handleStop = (e) => {
    }
    saveData = () => {
        let elements = document.querySelectorAll('.img-output-container .p-relative');
        let arrayOfImgs = []
        for (let i = 0; i < elements.length; i++) {
            console.log(elements[i])
            let element = elements[i].style.transform;
            let position_x = 0, position_y = 0, width = 0, height = 0,
                startTime = this.startTime, finishTime = startTime + 4 , file = {};

            position_x = parseInt(element.split('(').pop().split('px')[0]);
            position_y = parseInt(element.split(',').pop().split('px')[0]);

            let ele = elements[i].querySelector('img')
            if (ele) {
                width = parseInt(ele.getBoundingClientRect().width);
                height = parseInt(ele.getBoundingClientRect().height);

                let fileObject = this.state.fileObj.filter(file => file.fileBlob === ele.src );
                file = fileObject[0].fileUrl
            }
            let imgeAddone = {
                start_time: startTime, finish_time: finishTime,
                position_x: position_x, position_y: position_y,
                width: width, height: height,
                file: file
            };
            // send data to parent using callback function
            if (!isNaN(imgeAddone.position_x)) {
                arrayOfImgs.push(imgeAddone);
            }
        }
        if(!this.viewImgs){
            this.props.callbackFromParent(arrayOfImgs , "add");
        }else{
            this.props.callbackFromParent(arrayOfImgs , "edit");
            this.viewImgs = null;
        }
        this.setState({...this.state , fileObj : ''})
       
    }
    handleClose = (e) => {
        e.target.parentNode.parentNode.remove()
    }
    resetdata = () => {
        document.querySelector('.addon-images .saveChanges').classList.add('d-none');
        this.setState({...this.state , fileObj : '' })
    }
    closeTextEditor = () => {
        // hide text input and text editor
        document.querySelector('.text-editor-container').classList.add('d-none');
        document.querySelector('.text-input-container').classList.add('d-none');

        // hide save changes buttons
        document.querySelector('.addon-text .saveChanges').classList.add('d-none');
        // reset all data
        let btns = document.querySelectorAll('.text-editor-btn');
        for (let i = 0; i < btns.length; i++) {
            btns[i].classList.remove('text-orange');
        }
        document.querySelector("#text-input").value = ""
        document.querySelector("#text-input").classList = ""
    }
    showData = (imgsInfo) => {
        // remove the old data
        this.setState({ ...this.state, fileObj: [] })
        // make sure that all data removed before showing data
        let handleDeleteOldData = () => {
            if (this.state.fileObj.length === 0) {
                // close text editor
                this.closeTextEditor();
                // show save changes btn
                document.querySelector('.addon-images .saveChanges').classList.remove('d-none');
                // show img container
                document.querySelectorAll('.img-output-container').forEach(e => e.classList.remove('d-none'));
                let fileObj, fileObjArr = [];
                console.log(imgsInfo);
                imgsInfo.forEach(item => {
                    fileObj = { fileUrl: item.file, fileBlob: (typeof item.file === 'object') ? URL.createObjectURL(item.file) : item.file, fileDetails: item }
                    fileObjArr.push(fileObj)
                })
                this.setState({ ...this.state, fileObj: fileObjArr })
            } else {
                setTimeout(handleDeleteOldData, 10);
            }
        }
        handleDeleteOldData();
    }
    hideAddonsBtns = ()=>{
        document.querySelector('.addonTextAndImage').classList.add('d-none');

        let flagBtn = document.querySelector('#FlagBtn');
        flagBtn.classList.remove("bg-orange");
    }
    viewImgs = null;
    startTime = 0;
    componentWillReceiveProps(props){
        if(props !== this.props){
            if (props.viewImg) {
                this.showData(props.viewImg);
                this.viewImgs = props.viewImg
                if (props.startTime) {
                    this.startTime = props.startTime
                }
            } 
            else if (props.startTime) {

                this.startTime = props.startTime
            }
            else {
                this.resetdata();
            }
        }
    }
    render() {
        return (
            <div className="addon-images">
                <div
                    className="p-absolute w-100 text-left"
                    style={{ top: '7.4rem', right: '1rem' }}
                >
                    <Row className="row m-0 justify-content-end align-items-center">
                        <Col xl={1} md={2} xs={3} className="text-right p-0">
                            <label
                                for="file-input"
                                id='TextEditorBtn'
                                onClick={this.closeTextEditor}
                                style={{ height: '3rem', width: '3rem', fontSize: '1.2rem', cursor: "pointer" }}
                                className="rounded-circle text-center bg-dark-transperant p-2 border-0 text-white"
                            >
                                <ImageOutlinedIcon />
                            </label>
                            <input
                                id="file-input"
                                type="file"
                                className="d-none"
                                accept='image/*'
                                onChange={e => {
                                    // make sure that the user attache file
                                    if (e.target.files[0]) {
                                        let fileObj = { fileUrl : e.target.files[0] , fileBlob : URL.createObjectURL(e.target.files[0])}
                                        document.querySelector('.addon-images .saveChanges').classList.remove('d-none');
                                        this.setState({ ...this.state , fileObj : [...this.state.fileObj , fileObj]})
                                    }
                                }
                                }
                            />
                        </Col>
                    </Row>
                </div>
                <div>
                    {
                    (this.state.fileObj) ?
                            this.state.fileObj.map(file =>
                                <div
                                    className="p-absolute img-output-container"
                                    style={{ top: '0', left: '0', cursor: 'move' }}>
                                    <Draggable
                                        bounds=".video-addons-container"
                                        onStop={this.handleStop}
                                        defaultPosition={{x: (file.fileDetails)?file.fileDetails.position_x : 0 ,
                                                         y: (file.fileDetails)?file.fileDetails.position_y  : 0}}
                                        >
                                        <div className="p-relative" >
                                            <button
                                                type="button"
                                                className="close text-white p-absolute"
                                                aria-label="Close"
                                                style={{ top: '-8px', left: '-13px', zIndex: '1' }}
                                                onClick={this.handleClose}
                                            >
                                                <span aria-hidden="true">&times;</span>
                                            </button>
                                            <img
                                                style={{ maxWidth: '150px' }}
                                                src={file.fileBlob}
                                                alt="uploaded"
                                            />
                                        </div>
                                    </Draggable>
                                </div>
                            ) : ''}
                </div>
                <SaveChanges callbackFromParent={this.callback} />
            </div>
        )
    }
}